import RequestAbstract from '../abstract';

export default class Files extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/files';
    }
    async upload(file) {
        return this.loadWithAuth(
            this.link + '/upload',
            {
                method: 'POST',
                body: file
            },
            { fileUpload: true }
        );
    }
    async getFile(name) {
        return this.loadWithAuth(
            this.link + '/get/' + name,
            {
                method: 'GET'
            },
            { fileDownload: true }
        );
    }
}
